import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

// Auth via httpOnly cookie (configurado pelo backend em /api/auth/login).
// withCredentials: true garante o envio automático do cookie em cada request.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const ACT_AS_KEY = "actAsFornecedor";
export const getActAs = () => {
  try { return JSON.parse(sessionStorage.getItem(ACT_AS_KEY) || "null"); } catch { return null; }
};
export const setActAs = (v) => {
  if (v) sessionStorage.setItem(ACT_AS_KEY, JSON.stringify(v));
  else sessionStorage.removeItem(ACT_AS_KEY);
  window.dispatchEvent(new Event("act-as-change"));
};

api.interceptors.request.use((config) => {
  const a = getActAs();
  if (a?.id && (config.url || "").startsWith("/fornecedor")) {
    config.headers = config.headers || {};
    config.headers["X-Act-As-Fornecedor"] = a.id;
  }
  return config;
});
